function DDUMainDelta_Gear_RPM({value}) {
    const isOverLimit = value.rpm > (value["max-rpm"] * 0.90);

    return (
        <div className="flex flex-col w-full h-[65%]">
            <div className={`${value["is-delta-positive"] === "-" ? "bg-acc-green" : "bg-[#fffa7d]"} flex rounded-t-[10px] text-black w-full items-center justify-center py-[1px]`}>
                <h2 className="font-bold text-[20px]">{value["is-delta-positive"]}{value["delta-lap-time"]}</h2>
            </div>

            <div className={`${isOverLimit ? "animate-flash" : "animate-none"} ${value["ignition"] === 0 ? "bg-[#ff3e3e]" : value["is-engine-running"] === 0 ? "bg-[#f4b80b]" : "bg-[#137fec33]"} flex flex-col h-full w-full items-center justify-center rounded-b-[10px] relative`}>
                <svg className="material-symbols-outlined text-[20px] -rotate-90 absolute top-[10px] left-[5px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20px" width="20px"><path d="M8,21V15H3L12,4l9,11H16v6H8Z" className={`${value["is-left-direction-light"] === 1 ? "animate-flash-indicator stroke-acc-green" : "fill-transparent stroke-[#FFFFFF]"} stroke-[2.5px]`}></path></svg>
                <svg className="material-symbols-outlined text-[20px] rotate-90 absolute top-[10px] right-[5px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20px" width="20px"><path d="M8,21V15H3L12,4l9,11H16v6H8Z" className={`${value["is-right-direction-light"] === 1 ? "animate-flash-indicator stroke-acc-green" : "fill-transparent stroke-[#FFFFFF]"} stroke-[2.5px]`}></path></svg>

                {value["ignition"] === 0 ? (
                    <p className="text-[20px] font-bold uppercase">ignition off</p>
                ) : value["is-engine-running"] === 0 ? (
                    <p className="text-[20px] font-bold uppercase">engine off</p>
                ) : (
                    <>
                        <h1 className="font-bold text-[120px] mt-[-30px]">{value.gear}</h1>
                        <p className="mt-[-30px]">{value.rpm}</p>
                    </>
                )}
            </div>
        </div>
    );
}

export default DDUMainDelta_Gear_RPM;